import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

interface AccessibilityAnnouncerProps {
  message?: string;
}

const AccessibilityAnnouncer = ({ message }: AccessibilityAnnouncerProps) => {
  const location = useLocation();
  const announceRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // SSR safety check
    if (typeof document === 'undefined' || !announceRef.current) return;
    
    // Announce route changes
    const pageTitle = document.title;
    announceRef.current.textContent = `Navigated to ${pageTitle}`;
  }, [location]);

  useEffect(() => {
    if (message && announceRef.current) {
      announceRef.current.textContent = message;
    }
  }, [message]);

  return (
    <div
      ref={announceRef}
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
      role="status"
    />
  );
};

export default AccessibilityAnnouncer;